module.exports = __webpack_public_path__ + "img/line.80350487.svg";